import type { PhotoPolyline } from '@/entities/edit-area';

/** 닫힌 선(사진 px)을 SVG path 의 d 로 쓴다 — 'M x,y L x,y … Z', 마지막 점에서 첫 점으로 닫는다. */
export const closedPathOf = (points: PhotoPolyline): string =>
  `${points.map((point, index) => `${index === 0 ? 'M' : 'L'}${point.x},${point.y}`).join(' ')} Z`;
